<template>
    <Menu mode="horizontal" theme="light" active-name="1" class="header">
        <MenuItem name="0" id="header-logo">
            <a href="https://www.bluehci.com/index.html"><Image src="https://www.bluehci.com/img/lxsz-small-ll.png" fit="contain" width="112px" height="30px" alt="contain" /></a>
        </MenuItem>
        <MenuItem name="1" to="Blueiaas">
            云与基础设施
        </MenuItem>
        <MenuItem name="2" to="Blueoffice">
            云与智慧办公
        </MenuItem>
        <MenuItem name="3" to="Bluemanufacture">
            云与数字制造
        </MenuItem>
        <MenuItem name="4" to="Bluesolution">
            数字化IT咨询与运维
        </MenuItem>
        <MenuItem name="5" to="">
            照明与光线智能
        </MenuItem>
    </Menu>
</template>

<script>
export default {
  name: 'Header',
  components: {
  },
  setup() {
  },
  data(){
    return {
        breadcrumbList: [],
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>

<style lang="less" scoped>
ul.header{
  display: none;
}
@media (min-width: 1000px) {
  ul.header{
    display: block;
    width: 1600px;
    height: 32px;
    line-height: 32px;
    margin: 11px 0;
  }
  ul.header:after{
    background-color: #fff;
  }
  #header-logo:hover{
    border-bottom: 0;
  }
  #header-logo{
    border-bottom: 0;
  }
  ul.header > a.ivu-menu-item{
    padding: 0px;
    margin: 0 20px;
    border-bottom: 0;
    color: #000;
    transition: none;
  }
  ul.header > a.ivu-menu-item:hover{
    color: #000;
    border-bottom: 2px solid #000;
    transition: none;
  }
  ul.header > a.ivu-menu-item-active{
    color: #000;
    border-bottom: 0;
    transition: none;
  }
}
</style>
